import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {
	updateTicketCustomFieldValueMutation,
	UpdateCustomFieldValueInput,
} from './__generated__/updateTicketCustomFieldValueMutation.graphql';

// FOR-150 Task 4.1: ticketing-seam wrapper for the native `updateCustomFieldValue`
// mutation. Ticket custom fields are now stored in Forecast's native
// custom-field-service and read through the `CustomFieldValueV2Connection` on
// `Ticket.customFields`; writes go per-field through this native mutation instead
// of the old `updateTicket(customFields: [...])` passthrough.
//
// The payload node's global id (`TICKET:key:ticket_number`) is the same id the
// panel fragment reads on `Ticket.customFields.edges.node`, so Relay merges the
// returned scalars onto the existing store record by id — no explicit updater
// needed for in-place value edits. `displayValue` MUST be selected alongside
// `value`: for a dropdown the panel renders `displayValue ?? value` in read mode,
// so omitting it would leave the human-readable label stale after a successful
// edit until the next refetch.
const mutation = graphql`
	mutation updateTicketCustomFieldValueMutation($input: UpdateCustomFieldValueInput!) {
		updateCustomFieldValue(input: $input) {
			customFieldValue {
				node {
					__typename
					id
					key
					type
					displayName
					value
					displayValue
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: UpdateCustomFieldValueInput,
	onCompleted?: (r: updateTicketCustomFieldValueMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<updateTicketCustomFieldValueMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'updateTicketCustomFieldValueMutation'};
